export default "__VITE_ASSET__mLkxlNkV__"